import QUERY from './live-exchange-rate.graphql'
import type {
  GQLLiveExchangeRate,
  GQLLiveExchangeRateVariables,
} from './generated/live-exchange-rate'

export function useLiveExchangeRate(currencyFrom: string, currencyTo: string) {
  const { $apollo } = useNuxtApp()

  const liveRate = ref<number | null>(null)
  onMounted(async () => {
    const logger = useLogger('use-live-exchange-rate')
    try {
      const { data, errors } = await $apollo.query<
        GQLLiveExchangeRate,
        GQLLiveExchangeRateVariables
      >({
        query: QUERY,
        variables: { currencyFrom, currencyTo },
      })
      if (errors) {
        logger.error(errors[0])
        return
      }
      if (data.liveRate === null) {
        return
      }
      liveRate.value = parseFloat(formatRate(data.liveRate))
    } catch (err) {
      logger.error(err)
    }
  })

  return liveRate
}
